import React, { useState, useEffect } from "react";
import { Navbar } from "../Navbar/Navbar";
import { ThemeContext } from "../../Context/theme";

import "./Header.css";

export const Header = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const threshold = 30; 
      setIsSticky(window.pageYOffset > threshold);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <header className={`header ${themename} ${isSticky ? "sticky" : ""}`}>
 
          <Navbar />
    
      </header>
      {isSticky && <div className="empty-navbar" />}
    </>
  );
};
